<template>

  <div>
    <h1 :class="$style.title">
      {{ timeoutMessage }}
      <template v-if="resource">
        {{ resource }}
      </template>      
    </h1>
  </div>
  
</template>

<script>

  import texts from '../constants/display-texts.js'

export default {
    name: "Timeout",
    page: {
      title: texts.TimeoutPageTitle,
      meta: [{ name: 'description', content: texts.TimeoutMessageMetaDescription }],
  },
    props: {
      resource: { type: String, default: '' },
    },    
    components: { 
    },
    data() {
      return {
        timeoutMessage: texts.TimeoutMessage,
        offlineConfirmed: true,
      }
    },
  }
</script>

<style lang="scss" module>

  .title {
    text-align: center;
  }

</style>
